export default __webpack_public_path__ + "static/media/javascript_icon.621f6061.png";